import {TextField, TextFieldProps} from "@mui/material";
import pxToRem from "hooks/usePxToRem";
import {forwardRef} from "react";

type Props = TextFieldProps & {test?: any};

const ProcessInput = forwardRef((props: Props, ref) => {
  const {size = "small"} = props;
  return (
    <TextField
      inputRef={ref}
      // ref={ref}
      size={size}
      inputProps={{
        style: {
          fontSize: pxToRem(16),
        },
        ...props.inputProps,
      }}
      {...props}
    />
  );
});

ProcessInput.displayName = "ProcessInput";

export default ProcessInput;
